<template>
  <div id="app" class="app flex flex-col font-light relative w-full overflow-hidden" ref="app">
    <div class="canvas w-full h-full relative transform duration-200 ease-in-out">
      <div class="top bg-idc-blue-dark absolute z-10 w-full h-40 transform duration-200 ease-in-out sm:h-48" ref="top">
        <div class="container mx-auto py-4 px-2 sm:px-4 sm:py-6">
          <div class="flex flex-col sm:flex-row">
            <div class="flex-1">
              <div class="text-xs text-blue-300 leading-tight">
                IDC White Paper – March 2020<br>
                Authors: Danielle Hernandez, Philip Carter
              </div>
              <div class="mt-4 text-xs text-blue-300 leading-tight sm:mt-6">
                <h1 class="text-lg sm:text-3xl text-white">The Top 5 Tech Trends to Deliver Business Outcomes:<br>Understanding the Power of the Platform</h1>
              </div>
            </div>
            <div class="hidden sm:block sm:w-auto text-white text-xs leading-tight">
              <div class="flex sm:block">
                <span class="w-1/2 sm:w-auto">White Paper published by:</span>
                <img class="mt-2 w-1/2 sm:w-auto" src="./assets/idc_logo_white.svg" alt="">
              </div>
              <div class="mt-2">sponsored by SAP</div>
            </div>
          </div>
        </div>
      </div>
      <div class="fixed w-full top-0 bg-idc-blue-light z-10">
        <div id="menu" class="container mx-auto sm:w-4/5 flex items-center justify-center items-stretch text-xs leading-none sm:text-sm font-medium text-white h-16 sm:h-20">
          <a href="#video" class="hidden flex-1 flex-col justify-center transition-colors duration-500 hover:bg-blue-800 text-center px-2 border-r border-blue-800 sm:flex">
            <span class="flex-1 flex flex-col justify-center">Home</span>
            <span class="block bg-yellow-500 h-1 rounded mx-auto w-full sm:w-2/3 my-2" v-show="activeSection == 0"></span>
          </a>
          <a href="#glance" class="flex-1 flex flex-col justify-center transition-colors duration-500 hover:bg-blue-800 text-center px-2 border-r border-blue-800">
            <span class="flex-1 flex flex-col justify-center">At a Glance</span>
            <span class="block bg-yellow-500 h-1 rounded mx-auto w-full sm:w-2/3 my-2" v-show="activeSection == 1"></span>
          </a>
          <a href="#intro" class="flex-1 flex flex-col justify-center transition-colors duration-500 hover:bg-blue-800 text-center px-2 border-r border-blue-800">
            <span class="flex-1 flex flex-col justify-center">Introduction</span>
            <span class="block bg-yellow-500 h-1 rounded mx-auto w-full sm:w-2/3 my-2" v-show="activeSection == 2"></span>
          </a>
          <a href="#outcomes" class="flex-1 flex flex-col justify-center transition-colors duration-500 hover:bg-blue-800 text-center px-2 border-r border-blue-800">
            <span class="flex-1 flex flex-col justify-center">Deliver Business Outcomes</span>
            <span class="block bg-yellow-500 h-1 rounded mx-auto w-full sm:w-2/3 my-2" v-show="activeSection == 3"></span>
          </a>
          <a href="#trends" class="flex-1 flex flex-col justify-center transition-colors duration-500 hover:bg-blue-800 text-center px-2 border-r border-blue-800">
            <span class="flex-1 flex flex-col justify-center">Top 5 Tech Trends</span>
            <span class="block bg-yellow-500 h-1 rounded mx-auto w-full sm:w-2/3 my-2" v-show="activeSection == 4"></span>
          </a>
          <a href="#conclusion" class="flex-1 flex flex-col justify-center transition-colors duration-500 hover:bg-blue-800 text-center px-2">
            <span class="flex-1 flex flex-col justify-center">Conclusion</span>
            <span class="block bg-yellow-500 h-1 rounded mx-auto w-full sm:w-2/3 my-2" v-show="activeSection == 5"></span>
          </a>
        </div>
      </div>
      <full-page ref="fullpage" :options="fullpageOptions" id="fullpage">
        <div class="section" id="section1">
          <div class="h-16 sm:h-20"></div>
          <div class="bg-gray-400">
            <div class="flex lg:w-4/5 lg:mx-auto">
              <div class="w-1/2 border-r">
                <div class="relative">
                  <img class="w-full transition-transform duration-200 transform origin-center hover:scale-105" src="./assets/philip_carter.png" alt="">
                  <a href="#" class="absolute tintBlue inset-0 flex items-center justify-center" @click.prevent="showVideo=carterUrl">
                    <div class="rounded-full w-10 h-10 sm:h-16 sm:w-16 bg-white shadow-md flex items-center justify-center -mt-16 sm:mt-0">
                      <span class="arrow-right ml-1"></span>
                    </div>
                  </a>
                  <div class="relative h-32 sm:absolute w-full sm:w-1/2 sm:left-0 sm:bottom-0 bg-idc-blue-dark p-4 sm:p-8 text-sm text-white leading-4">
                    <h3 class="mb-2 font-medium">Philip Carter</h3>
                    The Top 5 Tech Trends to Deliver Business Outcomes
                  </div>
                </div>
              </div>
              <div class="w-1/2">
                <div class="relative">
                  <img class="w-full transition-transform duration-200 transform origin-center hover:scale-105" src="./assets/danielle_hernandez.png" alt="">
                  <a href="#" class="absolute tintBlue inset-0 flex items-center justify-center" @click.prevent="showVideo=hernandezUrl">
                    <div class="rounded-full w-10 h-10 sm:h-16 sm:w-16 bg-white shadow-md flex items-center justify-center -mt-16 sm:mt-0">
                      <span class="arrow-right ml-1"></span>
                    </div>
                  </a>
                  <div class="relative h-32 sm:absolute w-full sm:w-1/2 right-0 bottom-0 bg-idc-blue-dark p-4 sm:p-8 text-sm text-white leading-4 text-right">
                   <h3 class="mb-2 font-medium">Danielle Hernandez</h3>
                   Power of the<br/> Platform
                 </div>
               </div>
             </div>
            </div>
         </div>
         <div class="relative h-20 w-full">
           <div class='icon-scroll'></div>
         </div>
       </div>
       <div class="section" id="section2">
        <div class="container mx-auto p-8">
          <div class="hidden sm:block h-16 sm:h-20"></div>
          <h2 class="font-light text-2xl sm:text-4xl text-blue-800 mb-4 text-center leading-tight">At a Glance</h2>
          <ul class="w-auto sm:w-4/5 mx-auto text-lg text-gray-800 leading-tight">
            <li class="list-disc mb-4">
              <div class="m-1 h-full sm:m-1">
                The role of technology in transforming business models will continue to accelerate exponentially.
              </div>
            </li>
            <li class="list-disc mb-4">
              <div class="m-1 h-full sm:m-1">
                The sphere of influence of forward-looking technology leaders has the potential to expand in parallel if they focus on delivering business outcomes.
              </div>
            </li>
            <li class="list-disc mb-4">
              <div class="m-1 h-full sm:m-1">
                IDC has identified five key trends that we believe technology leaders should focus on to make or save money.
              </div>
            </li>
            <li class="list-disc mb-4">
              <div class="m-1 h-full sm:m-1">
                There is a close link between use cases that are business oriented and those that are enabled by technology.
              </div>
            </li>
            <li class="list-disc mb-4">
              <div class="m-1 h-full sm:m-1">
                IDC believes the technology architectures of the future will be platform oriented to enable a seamless flow of data internally and externally to the ecosystem.
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="section" id="section3">
        <div class="flex flex-col h-full">
          <div class="bg-gray-200">
            <div class="h-16 sm:h-20"></div>
            <div class="container mx-auto p-8">
              <h2 class="font-light text-2xl sm:text-4xl text-blue-800 mb-4 text-center leading-tight">Introduction</h2>
              <div class="w-auto sm:w-4/5 mx-auto text-lg text-gray-800 leading-tight">
                <p class="mb-4">
                  As we move into the next decade, the role of technology to transform businesses will continue to expand exponentially. Technology leadership roles will need to be redefined and new roles will be created. Whether you are a CIO, a CTO, a chief data officer, or any other technology leader, your sphere of influence will potentially grow in 2020 and beyond. Being aware of, and acting on, these game-changing trends with a laser focus on either making or saving money by delivering concrete business outcomes will be the difference between success and failure.
                </p>
                <p class="mb-4">
                  IDC's research shows that only 19% of organizations are generating net new revenue streams from digital investments, despite spending $1.2 trillion on digital transformation (DX) initiatives in 2019. In parallel, only 25% of organizations are delivering bottom-line growth from their technology investments. IDC refers to these organizations as the "digital moneymakers."
                </p>
              </div>
            </div>
          </div>
          <div class="bg-idc-blue-dark flex-1">
            <div class="container mx-auto p-6">
              <div class="flex items-center w-auto sm:w-4/5 mx-auto">
                <p class="flex-1 font-light leading-tight text-lg sm:text-2xl text-white mb-4 text-left">
                  IDC believes the anchor point to deliver business value from technology investments will shift from applications (which encouraged data fragmentation) to platforms (which will enable a more seamless flow of data across internal and external environments).
                </p>
                <div class="w-1/4"><img class="w-4/5 mx-auto" src="./assets/quote.svg" alt=""></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" id="section4">
        <div class="flex flex-col h-full">
          <div class="bg-gray-200">
            <div class="h-16 sm:h-20"></div>
            <div class="container mx-auto p-8">
              <h2 class="font-light text-2xl sm:text-4xl text-blue-800 mb-4 text-center leading-tight">Why do These Trends Matter to Technology Leaders</h2>
              <div class="w-auto sm:w-4/5 mx-auto text-lg text-gray-800 leading-tight">
                <p class="mb-4">
                  As part of this, IDC believes a new technology architecture will be critical for organizations aiming to deliver business outcomes from their digital investments. The key to delivering business value will shift from applications (which encouraged data fragmentation) to platforms (which will enable a more seamless flow of data across internal and external environments).
                </p>
                <p class="mb-4">
                  The CIOs, CTOs, and chief data officers of the future will need to understand the potential of this approach to chart the next phase of their personal careers and take technology leadership to the board across all industries.
                </p>
                <p class="mb-4">
                  The White Paper showcases the five key trends and looks at the role this new platform architecture will play.
                </p>
              </div>
            </div>
          </div>
          <div class="bg-idc-blue-dark flex-1">
            <div class="container mx-auto p-6">
              <div class="flex items-center w-auto sm:w-4/5 mx-auto">
                <p class="flex-1 font-light leading-tight text-lg sm:text-2xl text-white mb-4 text-left">
                  IDC research shows that only 19% of organizations are delivering net new revenue streams from digital investments and only 25% are reducing costs. These organizations are the moneymakers and money savers.
                </p>
                <div class="w-1/4"><img class="w-4/5 mx-auto" src="./assets/quote.svg" alt=""></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" id="section5">
        <div class="slide" data-anchor="slide1">
          <div class="flex flex-col h-full">
            <div class="h-16 sm:h-20"></div>
            <div class="container sm:mx-auto">
              <div class="flex items-center sm:w-4/5 px-4 sm:mx-auto mt-6">
                <div class="flex items-center justify-center font-black text-4xl sm:text-6xl text-blue-800 border border-gray-400 p-8 h-16 w-16 sm:h-24 sm:w-24 rounded-full leading-none mr-4 shadow">
                  <div class="flex items-start">
                    <span class="font-light text-lg sm:text-3xl">#</span>1
                  </div>
                </div>
                <div class="">
                  <span class="sm:text-2xl leading-none text-gray-600">Top 5 Tech Trends</span>
                  <h2 class="text-xl sm:text-4xl font-light leading-tight text-blue-800">Integrated Technology Architectures</h2>
                </div>
              </div>
              <div class="w-auto sm:w-4/5 px-16 sm:px-0 leading-tight sm:leading-normal sm:text-lg sm:mx-auto">
                <p class="py-4 sm:py-10">
                  There is often a major overestimation of the maturity of organizations in terms of how modern and flexible their technology architectures actually are. Although there is plenty of discussion about leveraging emerging, innovative technologies to deliver new revenue streams, the reality is that most companies are still battling with complex (and costly) legacy systems. Organizations are often constrained by having to untangle this legacy, and new technology initiatives become what IDC calls islands of innovation — entirely disconnected from core IT and often stuck in proof-of-concept jail. This is a short cut to a dead-end, as there is no way of getting to scale. To get out of this "PoC jail," a next-generation technology architecture will be required — one that is platform oriented. The trick to monetizing digital at scale based on this technology platform-oriented business model is creating an integrated approach that brings the back office closer to the front office, thereby leveraging the multiplier effect that platforms have on business value as they enable the flow of data across the value chains of the future.
                </p>
              </div>
            </div>
            <div class="bg-gray-200 text-blue-600 flex-1 py-4">
              <div class="container sm:mx-auto">
                <div class="w-auto sm:w-4/5 px-16 sm:px-0 text-sm leading-tight sm:text-base sm:leading-snug sm:mx-auto">
                  <div class="flex flex-wrap items-start">
                    <div class="flex items-center pt-4 sm:pt-8">
                      <div class="w-16 sm:w-40">
                        <img class="w-4/5 mx-auto" src="./assets/icon_1.svg" alt="">
                      </div>
                      <div class="flex-1">
                        <h3 class="text-2xl sm:text-4xl">The Power of the Platform</h3>
                      </div>
                    </div>
                    <div class="flex">
                      <div class="hidden sm:block sm:w-40"></div>
                      <div class="flex-1">
                        <p class="pb-4 font-light leading-tight text-lg sm:text-xl">
                          The integration capabilities of the platform can be used to fast-track integration across all the business applications, systems, and apps distributed across on-premises, hosted, or public cloud. This will enable the creation of new workflows leveraging information across legacy and SaaS applications to build custom use cases on top of core functionalities.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slide" data-anchor="slide2">
          <div class="flex flex-col h-full">
            <div class="h-16 sm:h-20"></div>
            <div class="container sm:mx-auto">
              <div class="flex items-center sm:w-4/5 px-4 sm:mx-auto mt-6">
                <div class="flex items-center justify-center font-black text-4xl sm:text-6xl text-blue-800 border border-gray-400 p-8 h-16 w-16 sm:h-24 sm:w-24 rounded-full leading-none mr-4 shadow">
                  <div class="flex items-start">
                    <span class="font-light text-lg sm:text-3xl">#</span>2
                  </div>
                </div>
                <div class="">
                  <span class="sm:text-2xl leading-none text-gray-600">Top 5 Tech Trends</span>
                  <h2 class="text-xl sm:text-4xl font-light leading-tight text-blue-800">The Power of Data = Intelligence</h2>
                </div>
              </div>
              <div class="w-auto sm:w-4/5 px-16 sm:px-0 leading-tight sm:leading-normal sm:text-lg sm:mx-auto">
                <p class="pt-4 sm:pt-10 mb-2">
                  By 2020, 80% of enterprises will create data management and monetization capabilities, enhancing enterprise functions, strengthening competitiveness, and creating new sources of revenue.
                </p>
                <p class="pb-4 sm:pb-10">
                  Much has been said about data being the new oil that will fuel businesses in the future. But the reality is that it's not about the amount of data that organizations have access to, but how effective their decisions are based on that data. Data alone will not be the new oil — intelligence will fuel the future enterprise. Organizations that can create intelligent business processes to deliver contextualized and consent-based experiences will be the winners in this new data-driven world.
                </p>
              </div>
            </div>
            <div class="bg-gray-200 text-blue-600 flex-1 py-4">
              <div class="container sm:mx-auto">
                <div class="w-auto sm:w-4/5 px-16 sm:px-0 text-sm leading-tight sm:text-base sm:leading-snug sm:mx-auto">
                  <div class="flex flex-wrap items-start">
                    <div class="flex items-center pt-4 sm:pt-8">
                      <div class="w-16 sm:w-40">
                        <img class="w-4/5 mx-auto" src="./assets/icon_2.svg" alt="">
                      </div>
                      <div class="flex-1">
                        <h3 class="text-2xl sm:text-4xl">The Power of the Platform</h3>
                      </div>
                    </div>
                    <div class="flex">
                      <div class="hidden sm:block sm:w-40"></div>
                      <div class="flex-1">
                        <p class="pb-4 font-light leading-tight text-lg sm:text-xl">
                          The data management capabilities of the platform enable a deep understanding of all data, including its definition, meaning, provenance, lineage, and relationships. The data pipelines of the future will come from both internal and operational data sources, but also from the external world (in short, experience data from the ecosystem). To have such awareness of the data, technical metadata needs to be augmented with business context to identify the most valuable and most sensitive information for businesses by integrating data from many sources. This unified data management architecture (including the master data definitions) needs to provide the basis for intelligent technologies to be embedded within core applications to support the creation of more agile business processes.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slide" data-anchor="slide3">
          <div class="flex flex-col h-full">
            <div class="h-16 sm:h-20"></div>
            <div class="container sm:mx-auto">
              <div class="flex items-center sm:w-4/5 px-4 sm:mx-auto mt-6">
                <div class="flex items-center justify-center font-black text-4xl sm:text-6xl text-blue-800 border border-gray-400 p-8 h-16 w-16 sm:h-24 sm:w-24 rounded-full leading-none mr-4 shadow">
                  <div class="flex items-start">
                    <span class="font-light text-lg sm:text-3xl">#</span>3
                  </div>
                </div>
                <div class="">
                  <span class="sm:text-2xl leading-none text-gray-600">Top 5 Tech Trends</span>
                  <h2 class="text-xl sm:text-4xl font-light leading-tight text-blue-800">The Future of Digital Innovation</h2>
                </div>
              </div>
              <div class="w-auto sm:w-4/5 px-16 sm:px-0 leading-tight sm:leading-normal sm:text-lg sm:mx-auto">
                <p class="pt-4 sm:pt-10 mb-2">
                  From 2018 to 2023, 500 million new apps will be created — equal to the number built over the past 40 years. This app explosion will require the agile development of innovation capabilities. This includes the developer and user experience services that will rapidly enable the creation of net new applications.
                </p>
                <p class="pb-4 sm:pb-10">
                  To balance the need for speed with the need for control, organizations will have to put in place a standard framework across all technology capabilities, regardless of the deployment model. This framework should leverage a governance-as-code approach to generate dashboards and automatic alerts to provide visibility and auditability for the key stakeholders in IT and the business.
                </p>
              </div>
            </div>
            <div class="bg-gray-200 text-blue-600 flex-1 py-4">
              <div class="container sm:mx-auto">
                <div class="w-auto sm:w-4/5 px-16 sm:px-0 text-sm leading-tight sm:text-base sm:leading-snug sm:mx-auto">
                  <div class="flex flex-wrap items-start">
                    <div class="flex items-center pt-4 sm:pt-8">
                      <div class="w-16 sm:w-40">
                        <img class="w-4/5 mx-auto" src="./assets/icon_3.svg" alt="">
                      </div>
                      <div class="flex-1">
                        <h3 class="text-2xl sm:text-4xl">The Power of the Platform</h3>
                      </div>
                    </div>
                    <div class="flex">
                      <div class="hidden sm:block sm:w-40"></div>
                      <div class="flex-1">
                        <p class="pb-4 font-light leading-tight text-lg sm:text-xl">
                          IDC believes that staying relevant in this environment requires a cloud-based application development and deployment environment that accelerates the delivery of new digital products, services, and experiences linked to those increasingly intelligent business processes. As we move to a technology era increasingly dominated by hyperscaler cloud platforms, there is a requirement to be open to these platforms to deliver specific business use cases that are critical to the business. Therefore the business innovation capabilities of the platform (in a multicloud world) will be critical to deliver net new applications to the market.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slide" data-anchor="slide4">
          <div class="flex flex-col h-full">
            <div class="h-16 sm:h-20"></div>
            <div class="container sm:mx-auto">
              <div class="flex items-center sm:w-4/5 px-4 sm:mx-auto mt-6">
                <div class="flex items-center justify-center font-black text-4xl sm:text-6xl text-blue-800 border border-gray-400 p-8 h-16 w-16 sm:h-24 sm:w-24 rounded-full leading-none mr-4 shadow">
                  <div class="flex items-start">
                    <span class="font-light text-lg sm:text-3xl">#</span>4
                  </div>
                </div>
                <div class="">
                  <span class="sm:text-2xl leading-none text-gray-600">Top 5 Tech Trends</span>
                  <h2 class="text-xl sm:text-4xl font-light leading-tight text-blue-800">Platforms to Modernize the Core</h2>
                </div>
              </div>
              <div class="w-auto sm:w-4/5 px-16 sm:px-0 leading-tight sm:leading-normal sm:text-lg sm:mx-auto">
                <p class="pt-4 sm:pt-10 mb-2">
                  Sixty-five percent of organizations will aggressively modernize legacy systems with extensive new technology platform investments through 2023.
                </p>
                <p class="mb-2">
                  During the era of experimentation for digital transformation, standalone projects based on emerging technologies were frequently driven by different business departments (LOBs) and were created in silos. Security was an afterthought for these initiatives, and so they exposed many vulnerabilities to the organization. In addition, scarce innovation resources were spread across multiple pilots and many digital efforts were failing before they even got to production.
                </p>
                <p class="mb-2">
                  To bridge the scale gap, organizations set up a new digital structure to focus on the new while ringfencing the old enterprise IT environment (seen as an operational bottleneck) to deliver some level of agility.
                </p>
                <p class="pb-4 sm:pb-10">
                  It became clear that not only do these systems, processes, and people need to be integrated as part of an enterprisewide platform, but also that the core needed to be modernized to provide the necessary agile backbone, infused with intelligence, to help redefine and create new business processes in a more dynamic fashion.
                </p>
              </div>
            </div>
            <div class="bg-gray-200 text-blue-600 flex-1 py-4">
              <div class="container sm:mx-auto">
                <div class="w-auto sm:w-4/5 px-16 sm:px-0 text-sm leading-tight sm:text-base sm:leading-snug sm:mx-auto">
                  <div class="flex flex-wrap items-start">
                    <div class="flex items-center pt-4 sm:pt-8">
                      <div class="w-16 sm:w-40">
                        <img class="w-4/5 mx-auto" src="./assets/icon_4.svg" alt="">
                      </div>
                      <div class="flex-1">
                        <h3 class="text-2xl sm:text-4xl">The Power of the Platform</h3>
                      </div>
                    </div>
                    <div class="flex">
                      <div class="hidden sm:block sm:w-40"></div>
                      <div class="flex-1">
                        <p class="pb-4 font-light leading-tight text-lg sm:text-xl">
                          IDC predicts that by 2025, at least 90% of new enterprise application releases will include embedded AI functionality. Additionally, the development of use cases for technology leadership needs to be supported by the platform, as it enables the extension of existing applications and development of net new capabilities.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slide" data-anchor="slide5">
          <div class="flex flex-col h-full">
            <div class="h-16 sm:h-20"></div>
            <div class="container sm:mx-auto">
              <div class="flex items-center sm:w-4/5 px-4 sm:mx-auto mt-6">
                <div class="flex items-center justify-center font-black text-4xl sm:text-6xl text-blue-800 border border-gray-400 p-8 h-16 w-16 sm:h-24 sm:w-24 rounded-full leading-none mr-4 shadow">
                  <div class="flex items-start">
                    <span class="font-light text-lg sm:text-3xl">#</span>5
                  </div>
                </div>
                <div class="">
                  <span class="sm:text-2xl leading-none text-gray-600">Top 5 Tech Trends</span>
                  <h2 class="text-xl sm:text-4xl font-light leading-tight text-blue-800">A New Technology Leadership — Delivering the Use Case Journey</h2>
                </div>
              </div>
              <div class="w-auto sm:w-4/5 px-16 sm:px-0 leading-tight sm:leading-normal sm:text-lg sm:mx-auto">
                <p class="pt-4 sm:pt-10 mb-2">
                  By 2023, 30% of organizations will have defined a new technology leadership role combining CIO, CTO, CDO, and innovation functions to orchestrate the digital strategy in their organizations.
                </p>
                <p class="mb-2">
                  IDC believes the "use case" is the anchor that will enable technologies and business outcomes to drive technology leadership capabilities to the next level.
                </p>
              </div>
            </div>
            <div class="container sm:w-3/4 mx-auto relative flex-1 px-6">
              <div class="mt-10 sm:mt-0 text-blue-600 flex-1 py-4 sm:w-3/4 sm:mx-auto h-full">
                <img src="./assets/fig_1.svg" alt="">
              </div>
              <div class="absolute top-0 w-4/5 mx-auto font-bold text-blue-800 sm:text-2xl leading-tight sm:w-1/3 bg-white-fade p-2 rounded">
                A use case is a business initiative, enabled by technology, with measurable outcomes
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" id="section6">
        <div class="flex flex-col h-full">
          <div class="">
            <div class="h-16 sm:h-20"></div>
            <div class="container mx-auto p-8">
              <h2 class="font-light text-2xl sm:text-4xl text-blue-800 mb-4 text-center leading-tight">Conclusion: How the Digital Moneymakers Actually Deliver</h2>
              <div class="w-auto sm:w-4/5 mx-auto text-lg text-gray-800 leading-tight">
                <p class="mb-4">
                  IDC predicts that 75% of organizations will be digitally transformed over the next decade — and that the rest will fall out of business. The difference between the winners and losers will be an organization's ability to build out a data-driven, platform-enabled, and ecosystem-centric business model. To win this 10-year race to become a digital business, organizations need a new way of thinking, acting, measuring, and reporting success. The outcome will be a shift from traditional linear value chains to a model where all ecosystem interactions are part of a continuous feedback loop underpinned by a platform that enables the seamless flow of data across every single person and organization in the value chain.
                </p>
                <p class="mb-4">
                  This platform is a flexible application infrastructure architecture that enables the orchestration and automation of end-to-end business processes and the creation of a launchpad for business innovation capabilities.
                </p>
                <p class="mb-4">
                  This is done by leveraging the following key capabilities:
                </p>
                <ul class="font-medium text-blue-600 mb-4 ml-5">
                  <li class="list-disc mb-1">Cross-silo analytics </li>
                  <li class="list-disc mb-1">Intelligent technologies (such as AI, IoT, and intelligent RPA)</li>
                  <li class="list-disc mb-1">Application development, integration, and extension </li>
                  <li class="list-disc mb-1">Database and data management</li>
                </ul>
                <img class="sm:w-4/5 mx-auto my-8" src="./assets/fig_3.svg" alt="">
              </div>
            </div>
            <div class="bg-idc-blue-dark py-10">
              <div class="w-auto sm:w-4/5 mx-auto text-lg text-white leading-tight">
                <div class="flex flex-wrap">
                  <div class="w-full sm:w-1/2">
                    <h3 class="block sm:hidden px-4 font-light text-xl sm:text-2xl leading-tight mb-4">The Top 5 Tech Trends to Deliver Business Outcomes: Understanding the Power of the Platform</h3>
                    <a href="https://www.sap.com/tech-trends" target="_blank" class="w-full" @click="track('Exit to sap.com')">
                      <img class="w-4/5 mx-auto my-8" src="./assets/white_paper.png" alt="">
                    </a>
                  </div>
                  <div class="w-full sm:w-1/2">
                    <div class="px-4">
                      <h3 class="hidden sm:block font-light text-xl sm:text-2xl leading-tight mb-4">The Top 5 Tech Trends to Deliver Business Outcomes: Understanding the Power of the Platform</h3>
                      <p>
                        Use the power of the platform to deliver business value
                      </p>
                      <ul class="text-blue-100 mb-4 ml-5">
                        <li class="list-disc mb-1">Technology will continue to play an ever-greater role in transforming business models.</li>
                        <li class="list-disc mb-1">
                          Intelligent technologies (such as AI, IoT, and intelligent RPA)IDC believes that the technology architectures of the future will be platform-oriented to enable a seamless flow of data across your business ecosystem.
                        </li>
                        <li class="list-disc mb-1">Leaders will succeed by focusing on delivery of improved business outcomes.</li>
                        <li class="list-disc mb-1">Technology-enabled use cases that are business-oriented are key to those outcomes.</li>
                      </ul>
                      <a href="https://www.sap.com/tech-trends" target="_blank" class="block w-3/4 mx-auto bg-white rounded-full border border-white px-4 py-2 my-8 text-center text-idc-blue-light hover:bg-idc-blue-light hover:text-white" @click="track('Exit to sap.com')">
                        DOWNLOAD WHITE PAPER
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container mx-auto p-8">
              <div class="w-auto sm:w-4/5 mx-auto flex items-center justify-between">
                <img class="mr-4" src="./assets/idclogocolour.svg" alt="">
                <h2 class="font-light text-2xl sm:text-4xl text-blue-800 mb-4 leading-tight">About IDC</h2>
              </div>
              <div class="w-auto sm:w-4/5 mx-auto text-lg text-gray-800 leading-tight mt-12">
                <p class="mb-4">
                  International Data Corporation (IDC) is the premier global provider of market intelligence, advisory services, and events for the information technology, telecommunications, and consumer technology markets. IDC helps IT professionals, business executives, and the investment community make fact-based decisions on technology purchases and business strategy. More than 1,100 IDC analysts provide global, regional, and local expertise on technology and industry opportunities and trends in over 110 countries worldwide. For 50 years, IDC has provided strategic insights to help our clients achieve their key business objectives. IDC is a subsidiary of IDG, the world's leading technology media, research, and events company.
                </p>
                <div class="flex">
                  <div class="w-1/3 mr-8">
                    <div class="text-idc-blue-dark font-bold">IDC UK</div>
                    <p>
                      5th Floor, Ealing Cross<br>
                      85 Uxbridge Road<br>
                      London<br>
                      W5 5TH<br>
                      44.20.8987.7100<br><br>
                      Twitter: <a href="https://twitter.com/idc" target="_blank">@IDC</a><br>
                      <a href="https://idc-community.com" target="_blank">idc-community.com</a><br>
                      <a href="https://idc.com" target="_blank">idc.com</a>
                    </p>
                  </div>
                  <div class="w-1/3">
                    <div class="text-idc-blue-dark font-bold">IDC Global Headquarters</div>
                    <p>
                      5 Speen Street<br>
                      Framingham, MA 01701<br>
                      USA<br>
                      508.872.8200<br>
                    </p>
                  </div>
                </div>
                <div class="mt-12 text-sm">
                  <h5 class="text-xl font-light text-gray-700">Copyright and Restrictions</h5>
                  <p class="my-4">
                    External Publication of IDC Information and Data — Any IDC information that is to be used
                  </p>
                  <p class="my-4">
                    in advertising, press releases, or promotional materials requires prior written approval from the appropriate IDC Vice President or Country Manager. A draft of the proposed document should accompany any such request. IDC reserves the right to deny approval of external usage for any reason.
                  </p>
                  <p class="my-4 font-bold text-gray-500">
                    Copyright &copy; 2020. Reproduction without written permission is completely forbidden.
                  </p>
                  <p class="my-4 font-bold text-idc-blue-dark text-right">
                    IDC #EUR145995120
                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </full-page>
  </div>
  <div class="fixed inset-0 bg-transparent-black flex justify-center items-center z-10 w-full h-full" v-if="showVideo">
      <div class="w-full rounded shadow md:w-2/3 sm:mt-2" >
        <div class="w-full relative aspect-16x9">
          <span class="absolute bg-white text-black px-2 rounded-full cursor-pointer" style="top: -40px; right: 0px" @click="showVideo = false">Close ×</span>
          <video class="absolute w-full" controls autoplay>
            <source :src="`/video/${showVideo}`"
            type="video/mp4">
            Sorry, your browser doesn't support embedded videos.
          </video>
        </div>
      </div>
    </div>
    <div class="fixed inset-0 bg-transparent-black flex justify-center items-center w-full h-full" style="z-index: 200" v-if="showIntro">
      <div class="w-full rounded shadow md:w-2/4 sm:mt-2" >
        <div class="w-full relative max-h-screen overflow-y-auto p-4 sm:p-0">
          <span class="absolute bg-white text-black px-2 rounded-full cursor-pointer top-0 right-0 mt-1 mr-1" @click="closeIntro">Close ×</span>
          <div class="text-sm sm:text-base p-4 sm:p-12 bg-gray-200 rounded">
            <div class="flex items-center justify-between mb-4 sm:mb-8">
              <h2 class="font-bold text-xl leading-none sm:text-4xl">A message from IDC</h2>
              <img class="w-24 sm:w-40" src="./assets/idclogocolour.svg" alt="">
            </div>
            <p class="mb-4">
              Please note that this White Paper was published before these challenging times became a reality across the global economy. However, the research, insights, and recommendations provided are all very much still valid. The imminent economic downturn globally will actually compel organizations to continue to invest in their digital initiatives — but the pressure on financial outcomes will increase. As part of this, IDC believes that technology will play a critical role in the recovery of the economy, as the pandemic has highlighted the potential of digital to multiply our value through intelligence, data, and a shift to platform-based business models.
            </p>
            <p class="mb-4">
              As an IT executive, your sphere of influence will potentially grow in 2020 and beyond, but the new normal requires a new mindset. In case you are still wondering which areas of your business are ideal for adoption of disruptive technologies, we invite you to start asking different questions to uncover the potential value that digital initiatives can deliver. This will require an unwavering focus on the following:
            </p>
            <ul class="list-disc ml-8 font-medium mb-4">
              <li class="mb-1">Establishing a future-proof technology architecture that underpins a business model that adapts and responds to uncertain external market pressures </li>
              <li class="mb-1">Creating a data strategy based on data pipelines feeding into and out of that integrated technology architecture</li>
              <li class="mb-1">Delivering digital innovation at scale so that new capabilities can be delivered in an unpredictable environment </li>
              <li class="mb-1">Modernizing core IT environments to establish the backbone for agile business models</li>
              <li class="mb-1">Developing a use-case journey that aligns the C-Suite to deliver on the ROI promise and deliver financial outcomes from digital </li>
            </ul>
            <p class="mb-4">
              As these challenging times fundamentally shake up how we live, learn, socialize, and work, governments are taking drastic measures to keep citizens safe and healthy. IDC believes that the response of organizations in these uncertain times will shape the market perception of their brand in the next 10 years — technology leaders have a unique opportunity to define the future of business and society in a fundamentally positive fashion.
            </p>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      activeSection: 0,
      showVideo: false,
      showIntro: true,
      carterUrl: '200214_IDC_Carter_v01_720p.mp4',
      hernandezUrl: '200214_IDC_Hernandez_v01_720p.mp4',
      fullpageOptions: {
        licenseKey: '4FC0A9AE-4AA74B95-B4499A24-98221A40',
        navigation: true,
        navigationPosition: 'right',
        scrollOverflow: true,
        menu: '#menu',
        anchors: ['video', 'glance', 'intro', 'outcomes', 'trends', 'conclusion'],
        verticalCentered: true,
        afterLoad: this.afterLoad,
        onLeave: this.onLeave,
        afterRender: this.afterRender
      }
    }
  },
  components: {

  },
  watch: {
    showVideo: function (value) {
      if (value) {
        this.$gtag.event('Video Play', {
          event_category: 'engagement'
        })
      } else {
        this.$gtag.event('Video Stop', {
          event_category: 'engagement'
        })
      }
    }
  },
  methods: {
    onLeave: function (origin, destination, direction) {
      this.activeSection = destination.index
      if (destination.index === 0) {
        this.$gtag.pageview({
          page_path: '/'
        })
        this.$refs.app.classList.remove('hidemenu')
      }
      if (destination.index !== 0) {
        this.$gtag.pageview({
          page_path: '/' + this.fullpageOptions.anchors[destination.index - 1]
        })
        this.$refs.app.classList.add('hidemenu')
      }
    },
    afterLoad: function (origin, destination, direction) {
      // console.log(origin);
      // console.log(destination);
      // console.log(direction);
    },
    afterRender: function () {
      if (this.showIntro) {
        this.$refs.fullpage.api.setAllowScrolling(false)
      }
    },
    closeIntro: function () {
      this.showIntro = false
      this.$refs.fullpage.api.setAllowScrolling(true)
    },
    track: function (action) {
      this.$gtag.event(action, {
        event_category: 'engagement'
      })
    }
  },
  created: function () {
    this.$gtag.pageview({
      page_path: '/'
    })
  }
}
</script>
<style scoped type="text/css">
  .aspect-16x9 {
    padding-bottom: 56.25%;
  }
</style>
